import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Infrastructure() { 
  useEffect(() => {
    document.title = 'Infrastructure -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>Infrastructure</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Infrastructure</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                    <p>The School has a large playground, Physics, Chemistry, Biology, Biotechnology and Computer Laboratories, well equipped Library, Music Room, Outdoor Stage, Basketball Court and other amenities to meet the academic and extracurricular needs of students.</p>
                    <div className="infrapgh">
                    <h5>Science Labs</h5>
                   <p>At Mercy Memorial School, students are encouraged to test what they learn in classrooms, prove concepts and validate hypotheses. There are state-of-the-art laboratories for Physics, Chemistry, Biology and Computer Science. Many interesting group projects are given to students with clear but open-ended guidance from the teachers. This gives students a chance to experiment together and so learn cooperatively, a skill that is irreplaceable in today’s world. The laboratories are well designed, well lit and airy. A lot of effort and planning has gone into making the labs safe and secure for students.</p>
               </div> 
               <div className="infrapgh">
                    <h5>Physical Education</h5>
                  <p>The school promotes an effective physical education. Mercy memorial School has a large playground and students are encouraged to take up sports. A large playground with many sporting options encourages students to not only develop skills in different sporting fields but also develop sound physical fitness that keeps them healthy and fit.</p>
               </div> 
                 <div className="infrapgh">
                    <h5>Library</h5>
                  <p>The school Library has been refurnished and re-stocked and the school is constantly improving the catalog of print and digital books. There is large space for research and reading and the library has been designed to provide the students with a meaningful and quiet environment for study and intellectually creative thought. Students are encouraged to utilize the library throughout the year. The MMS Library supports the educational objectives of the school by making it integral to the independent learning processes within the school. It enables students to become more responsible for their own learning and prepare for the challenges ahead by helping them develop their research and analytical skills.</p>
                </div> 
                 <div className="infrapgh">
                   <h5>Music Room</h5>
                   <p>MMS has a strong belief that art and music are not extra-curricular at all but must be an entitlement of all students and brings out the best in every student. The school’s Music Room helps students to be creative and develop and inculcate talent that makes them who they are.</p>
                 </div>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Infrastructure;
